<template>
  <div class="devmanage">
    <div class="toolbar clearfix">
      <div class="tool-first">
        <div class="clearfix">
          <el-tabs v-model="status" @tab-click="pageData(1)">
            <el-tab-pane label="全部用户" name='-1' :disabled="loading"></el-tab-pane>
            <el-tab-pane label="正式用户" name="2" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="试用用户" name="1" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="过期用户" name="3" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="未生效用户" name="0" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="禁用用户" name="4" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="待审核用户" name="6" :disabled="loading"></el-tab-pane>
            <el-tab-pane label="审核拒绝用户" name="7" :disabled="loading"></el-tab-pane>
            <!-- <el-tab-pane label="其他用户" name="5" :disabled="loading"></el-tab-pane> -->
          </el-tabs>
          <div class="absolute-btn" v-if="valid('API_MANAGE_USER')">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="goAddDev" >添加开发者</el-button>
          </div>
        </div>
      </div>
      <div class="tool-third fr">
        <el-input placeholder="请输入企业名称....." v-model="companyName" @keyup.enter.native="pageData(1)" class="input-with-select" clearable maxlength="64">
          <el-button slot="append" icon="el-icon-search" @click="pageData(1)"></el-button>
        </el-input>
      </div>
    </div>
    <div class="content_wrapper">
      <el-table
        v-loading="loading"
        :data="developerData"
        border
        fit
        :height="height"
        header-row-class-name="header-row-class-name"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          label="企业名称">
          <template slot-scope="scope">
            <div>{{scope.row.companyName}}</div>
            <div>({{scope.row.mobile}})</div>
          </template>
        </el-table-column>
        <el-table-column
          label="开通类型"
          align="center"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.type === 1">按时间</div>
            <div v-else>按数量</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="registerTime"
          align="center"
          label="注册时间">
        </el-table-column>
        <el-table-column
          label="接口类型"
          align="center"
          width="100">
          <template slot-scope="scope">
            <div v-for="item of scope.row.apiDeveloperConfigDtoList" :key="item.id">
              <div>{{item.apiResourceDto.name}}</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="registerTime"
          align="center"
          label="资源类型"
          width="160">
          <template slot-scope="scope">
            <div v-for="item of scope.row.apiDeveloperConfigDtoList" :key="item.id">
              <div v-if="item.apiResourceDto.resourceType === 0">/</div>
              <div v-if="item.apiResourceDto.resourceType === 1">普通</div>
              <div v-if="item.apiResourceDto.resourceType === 2">精品</div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          label="接口状态"
          width="160">
          <template slot-scope="scope">
            <div v-for="item of scope.row.apiDeveloperConfigDtoList" :key="item.id">
              <span v-if="item.status === 2" style="color:#36B935;">服务中</span>
              <span v-if="item.status === 1" style="color:#479efe;">试用</span>
              <span v-if="item.status === 3" style="color:#666;">过期</span>
              <span v-if="item.status === 0" style="color:#878787;">未生效</span>
              <span v-if="item.status === 4" style="color:#ed4a3a;">禁用</span>
              <span v-if="item.status === 6" style="color:#878787;">待审核</span>
              <span v-if="item.status === 7" style="color:#ed4a3a;">审核拒绝</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <template v-if="valid('API_MANAGE_USER')">
              <el-button
                v-if="judgeVerify(scope.row.apiDeveloperConfigDtoList, [6, 7])"
                type="text"
                size="small"
                @click="viewPass(scope.row.id)"
              >
                审核通过
              </el-button>
              <el-button
                v-if="judgeVerify(scope.row.apiDeveloperConfigDtoList, [6])"
                type="text"
                size="small"
                @click="viewReject(scope.row.id)"
              >
                审核拒绝
              </el-button>
            </template>
            <el-button
              type="text" size="small"
              @click="viewDevInfo(scope.row.id)"
            >
              详情
            </el-button>
            <el-button
              v-if="!judgeVerify(scope.row.apiDeveloperConfigDtoList, [6, 7])"
              type="text"
              size="small"
              @click="viewCustomer(scope.row.id,scope.row.companyName)"
            >
              调用统计
            </el-button>
            <el-button
              v-if="!judgeVerify(scope.row.apiDeveloperConfigDtoList, [6, 7])"
              type="text"
              size="small"
              @click="viewInterface(scope.row.id)"
            >
              接口管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;margin-top:10px;">
        <el-pagination
          background
          @current-change="pageData"
          :current-page.sync="pageNumber"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script type="text/babel">
import editDevDialog from './edit-dialog/index.vue'
import devService from '@/service/devService'
import types from '@/vuex/mutation-types'
import adminMixin from '@/mixins/adminMixin'
import { mapMutations } from 'vuex'

export default {
  mixins: [adminMixin],
  components: {
    editDevDialog: editDevDialog
  },
  data () {
    return {
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      status: '-1',
      companyName: '',
      height: 600,
      total: 0,
      devDialogVisible: false,
      dialogVisible: false,
      developerData: [],
      activeName: ''
    }
  },
  mounted () {
    this.loadTableData()
  },
  methods: {
    ...mapMutations({
      commitCompanyInfo: types.COMPANY_INFO
    }),
    judgeVerify(list, statusArr) {
      return list.length === list.filter(item => statusArr.includes(item.status)).length
    },
    // 跳转新增开发者页面
    goAddDev () {
      this.$router.push({name: 'addDeveloper'})
    },
    // 翻页
    pageData (value) {
      this.pageNumber = value
      this.loadTableData()
    },
    // 加载页面数据
    async loadTableData () {
      this.loading = true
      let status = ''
      this.developerData = []
      if (this.status !== '-1') {
        status = this.status
      }
      // console.log(type)
      // if (type === 'load') {
      // alert(111)
      // this.pageNumber = 1
      // }
      devService.listDev({
        status: status,
        companyName: encodeURIComponent(this.companyName.trim()),
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      })
        .then(resp => {
          this.developerData = resp.content
          this.total = resp.totalElements
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          this.loading = false
        })
      // try {
      //   this.developerData = await devService.listDev({
      //     status: status,
      //     companyName: encodeURIComponent(this.companyName.trim())
      //   })
      // } catch (e) {
      //   this.$message.error(e && e.msg)
      // }
      // this.loading = false
    },
    // 查看接口管理
    viewInterface (id) {
      for (let i = 0; i < this.developerData.length; i++) {
        if (this.developerData[i].id === id) {
          this.commitCompanyInfo(this.developerData[i])
        }
      }
      this.$router.push({name: 'interfacemanage'})
    },
    viewPass(id) {
      devService.setDeveloperStatusPass({
        userId: id
      })
        .then(resp => {
          this.$message.success('审核通过成功！')
          this.loadTableData()
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    viewReject(id) {
      devService.setDeveloperStatusReject({
        userId: id
      })
        .then(resp => {
          this.$message.success('审核拒绝成功！')
          this.loadTableData()
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 查看开发者信息
    viewDevInfo (id) {
      for (let i = 0; i < this.developerData.length; i++) {
        if (this.developerData[i].id === id) {
          this.commitCompanyInfo(this.developerData[i])
        }
      }
      this.$router.push({name: 'devinfo'})
    },
    // 查看调用统计
    viewCustomer (id, companyName) {
      for (let i = 0; i < this.developerData.length; i++) {
        if (this.developerData[i].id === id) {
          this.commitCompanyInfo(this.developerData[i])
        }
      }
      this.$router.push({name: 'istatisticsCustomer'})
    }
  }
}
</script>
<style scoped>
  .devmanage {
    margin-top: 10px;
    background-color: #F3F5F8;
  }
  .devmanage .toolbar{
    padding: 20px;
    width: 100%;
    margin-bottom: 20px;
    background-color: #ffffff;
    position: relative;
  }
  .devmanage .toolbar .absolute-btn{
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .devmanage .toolbar .input-with-select {
    width: 300px;
  }
  .devmanage .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .devmanage .content_wrapper{
    padding: 16px;
    background-color: #ffffff;
  }
  .devmanage .content_wrapper .my-pagination{
    height: 50px;
    line-height: 50px;
  }

</style>
<style type="text/css">
  .devmanage .my-pagination *{
    color: #333333;
  }
  .devmanage .my-pagination {
    border:solid 1px #DFE5F0;
    border-top: none;
    padding-left: 20px;
    padding-top: 10px;
  }
  .devmanage  .toolbar .el-select .el-input__inner{
    color: #333333;
  }

</style>



// WEBPACK FOOTER //
// src/pages/admin/dev-manage/index.vue